import { createRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { usePhoneJsonEditorSession } from "@/components/phone-json-editor/phone-json-editor-session";
import { PhonePreviewPanel } from "@/components/phone-preview";
import { useCaseDetail } from "@/hooks/use-case-detail";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { versionLayoutRoute } from "./version-layout-route";

export const versionPreviewRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/preview",
  component: VersionPreviewPage,
});

function VersionPreviewPage() {
  const auth = useAuth();
  const { caseId, versionId } = versionPreviewRoute.useParams();
  const detailQuery = useCaseDetail(caseId);
  const version = detailQuery.data?.versions.find((v) => v.id === versionId);
  const editor = usePhoneJsonEditorSession();

  const previewQuery = useQuery({
    queryKey: ["case-preview", caseId, versionId],
    queryFn: () => api.getCasePreview(caseId, { versionId }),
    enabled: auth.status === "authed" && Boolean(versionId),
    refetchInterval: (q) => {
      const locales = q.state.data?.locales ?? [];
      if (locales.length === 0) return 4000;
      return 15000;
    },
  });

  return (
    <PhonePreviewPanel
      preview={previewQuery.data}
      isLoading={previewQuery.isLoading}
      isError={previewQuery.isError}
      preferredLocale={version?.locale}
      preferredVersionId={versionId}
      reloadNonce={editor.previewReloadKey}
    />
  );
}
